import React, { Component } from 'react';
import { gridSize } from './helpers';
import { constants } from './constants';
import { classNames } from './classNames';

class Cell extends Component {
  shouldComponentUpdate(nextProps) {
    return (
      this.props.value !== nextProps.value
            || this.props.isCorrect !== nextProps.isCorrect
            || this.props.isFocussed !== nextProps.isFocussed
            || this.props.isHighlighted !== nextProps.isHighlighted
            || this.props.isError !== nextProps.isError
    );
  }

  onClick(e) {
    e.preventDefault();
    e.stopPropagation();
    if (!this.props.isCorrect) this.props.handleSelect(this.props.x, this.props.y);
  }

  render() {
    const top = gridSize(this.props.y);
    const left = gridSize(this.props.x);

    let cellNumber = null;
    if (this.props.number !== undefined) {
      cellNumber = (
        <text
          x={left + 1}
          y={top + constants.numberSize}
          key="number"
          className="crossword__cell-number"
        >
          {this.props.number}
        </text>
      );
    }

    let cellValue = null;
    if (this.props.value !== undefined) {
      cellValue = (
        <text
          x={left + constants.cellSize * 0.5}
          y={top + constants.cellSize * 0.675}
          key="entry"
          className={classNames({
            'crossword__cell-text': true,
            'crossword__cell-text--focussed': this.props.isFocussed,
            'crossword__cell-text--error': this.props.isError,
            'crossword__cell-text--correct': this.props.isCorrect,
          })}
          textAnchor="middle"
        >
          {this.props.value}
        </text>
      );
    }

    let cellCorrect = null;
    if (this.props.isCorrect) {
      const radius = constants.cellSize / 2;
      cellCorrect = (
        <circle
          cx={left + radius}
          cy={top + radius}
          r={radius * 0.8}
          className={`crossword__cell-correct`}
        />
      )
    }

    return (
      <g onClick={this.onClick.bind(this)}>
        <rect
          x={left}
          y={top}
          width={constants.cellSize}
          height={constants.cellSize}
          className={`${classNames({
            crossword__cell: true,
            'crossword__cell--focussed': this.props.isFocussed,
            'crossword__cell--highlighted': this.props.isHighlighted,
            'crossword__cell--correct': this.props.isCorrect,
          })}`}
        />
        {cellCorrect}
        {cellNumber}
        {cellValue}
      </g>
    );
  }
}

export default Cell;
